module.exports = __webpack_public_path__ + "img/circlePlay-white.703de2f.png";